import React, { Suspense, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import Loader from 'components/Loader/Loader';
import CSS from "csstype";
import TickersPickerModal from 'components/TickersPickerModal/TickersPickerModal';
import FilterModal from 'components/FilterModal/FilterModal';
import AddParamsModal from 'components/AddParamsModal/AddParamsModal';
import FormulaModal from 'components/FormulaModal/FormulaModal';
import AreYouSureModal from 'components/AreYouSureModal/AreYouSureModal';
import { Modal, showModal } from 'store/reducers/modal';
import {
    addFilterQuery,
    filterSection,
    removeFilterParam,
    resetFilterQueries,
    selectFilterParam,
    sendFilteredColumns,
    setFilterParamsForWorkspace
} from 'store/reducers/FilterSlice';
import { getTabs, renameTab, updateAreaPickedTickers } from 'store/reducers/TabsSlice';
import { RootState } from 'store/store';
import Filter, { FilterParam } from 'utils/ticker-params-handler';
import { selectFilterColumn, setFilteredColumns, setSelectedTickers } from 'store/reducers/quotes';
import Error from 'utils/Notifications/Error';
import { setUploadedFile } from 'store/reducers/quotes';

const loaderStyle: CSS.Properties = {
    position: 'absolute',
    inset: 0,
    margin: '0 auto',
    zIndex: 3
}

export type AreYouSureActions = 'rename_tab';
export type Action = AreYouSureActions;

const ModalHandler = ({
    modals,
    showModal,
    filter_params,
    selected_filter_params,
    selectFilterParam,
    removeFilterParam,
    quotes,
    active_page_id,
    updateAreaPickedTickers,
    renameTab,
    getTabs,
    addFilterQuery,
    file_query,
    manual_query,
    filterSection,
    resetFilterQueries,
    setFilteredColumns,
    selectFilterColumn,
    filtered_columns,
    sendFilteredColumns,
    logic,
    setUploadedFile,
    setSelectedTickers,
    setFilterParamsForWorkspace
}) => {
    const actions = {
        are_you_sure: {
            rename_tab: ({
                new_name,
                tab_id
            }: { new_name: string, tab_id: string | number }) => {
                renameTab({
                    name: new_name,
                    id: tab_id
                });
                handleModal('are_you_sure', false);
            },
            cancel_rename: () => {
                getTabs()
                handleModal('are_you_sure', false);
            },
            apply_formula: ({
                query,
                section_id,
                applied_filter_names
            }: { query: string, section_id: number | string, applied_filter_names: string[] | undefined }) => {

                const check = Filter.validateFormula(query);
                //const st = selected_filter_params[caller];

                handleModal('are_you_sure', false);

                if (query === '') {
                    resetFilterQueries({
                        id: caller
                    });
                }
                if (typeof check === 'string') {
                    Error(check);
                    return;
                }
                handleModal("filter", false)
                filterSection({
                    query,
                    section_id
                });
            }
        }
    }

    const { caller, args } = modals;
    const {
        filter,
        ticker_picker,
        add_params,
        formula,
        are_you_sure
    } = modals.modals;

    const handleModal = (modal_type: Modal, action: boolean) => {
        showModal({
            modal_type,
            value: action
        });
    }

    const filter_modal_prop = selected_filter_params && caller && Array.isArray(selected_filter_params[caller]) ? selected_filter_params[caller] : [];
    const picked_tickers = caller && typeof quotes.quotes === 'object' && quotes.quotes[caller] ? quotes.quotes[caller].params : [];
    const picked_tickers_names = picked_tickers.map(ticker => ticker.Name.split('~')[0]);
    const addParamsOnChooseHandler = (param: FilterParam) => {
        if (param && caller) {
            selectFilterParam({
                id: caller,
                param
            });
        }
    }

    const addParamToFilteredColumns = (param: FilterParam) => {
        if (param && caller) {
            selectFilterColumn({
                column: param.name,
                id: caller
            });
        }
    }

    const addParamsOnRemoveHandler = (param: FilterParam) => {
        if (param && caller) {
            removeFilterParam({
                id: caller,
                param
            });
        }
    }

    const tickerPickerApplyClickHandler = (picked_tickers: string[]) => {
        if (picked_tickers.length === 0) {
            setUploadedFile({
                caller,
                name: '',
                names: []
            });
            setSelectedTickers({
                id: caller,
                data: []
            });
        }
        updateAreaPickedTickers({
            workspace_id: active_page_id,
            area_id: caller,
            picked_tickers: picked_tickers.filter(x => typeof x === 'string' && x.length > 0)
        });
    }

    const args_provided = typeof args === 'object';
    const add_params_with_args = args_provided && args.action === 'apply_params';
    const add_params_selected_filters = Array.isArray(filtered_columns[caller]) ? filtered_columns[caller].map(col => ({ name: col, type: 'Boolean' })) : [...filter_params];

    function findCallback(type: Modal, action: Action): Function {
        const found_action = actions[type] && typeof actions[type][action] === 'function' ? actions[type][action] : () => { console.log('not found') };
        return found_action;
    }

    function applyFormula(formula: string) {
        addFilterQuery({
            caller,
            manual_query: formula
        });
    }

    function onApplyFilterColumns() {
        if (Array.isArray(add_params_selected_filters) && add_params_selected_filters.length) {
            sendFilteredColumns({
                columns: add_params_selected_filters.map(item => item.name),
                id: caller
            });
        }
        handleModal('add_params', false);
    }

    const tp_close = () => handleModal('ticker_picker', false);
    const f_open = () => handleModal('filter', true);

    const memo_pt = useMemo(() => caller && quotes.selected_tickers[caller] ? quotes.selected_tickers[caller] : [], [quotes.selected_tickers, caller]);

    return (
        <>
            <Suspense fallback={<Loader style={loaderStyle} size="large"/>}>
            {
                ticker_picker &&
                <TickersPickerModal
                    table_id = { caller }
                    isOpen={ticker_picker}
                    onRequestClose={tp_close}
                    openFilterModal={f_open}
                    tabId={active_page_id}
                    applyCallback={tickerPickerApplyClickHandler}
                    picked_tickers = { memo_pt  }
                />
            }
            {
                filter &&
                <FilterModal
                    logic = { logic && caller && logic[caller] }
                    title="Фильтр"
                    isOpen={filter}
                    onRequestClose={() => handleModal('filter', false)}
                    openAddParamsModal={() => handleModal('add_params', true)}
                    openFormulaModal={() => handleModal('formula', true)}
                    openAreYouSureModal={() => handleModal('are_you_sure', true)}
                    closeAreYouSureModal={() => handleModal('are_you_sure', false)}
                    onRestoreFilter={ ({id}) => resetFilterQueries({ id }) }
                    list={filter_modal_prop}
                    onRemove={addParamsOnRemoveHandler}
                    picked_tickers = { caller && quotes.picked_tickers[caller] ? quotes.picked_tickers[caller] : picked_tickers_names }
                    table_id = { caller }
                    manual_query = { manual_query[caller] }
                    file_query = { file_query }
                />
            }
            {
                add_params &&
                <AddParamsModal
                    title="Добавить параметр"
                    isOpen={add_params}
                    onApplyClick = { add_params_with_args ? onApplyFilterColumns : () => handleModal('add_params', false) }
                    onRequestClose={ () => handleModal('add_params', false) }
                    onChoose={ add_params_with_args ? addParamToFilteredColumns : addParamsOnChooseHandler }
                    filter_params = { filter_params || [] }
                    selected_filter_params = { add_params_with_args ? add_params_selected_filters : filter_modal_prop }
                    onRemove = { add_params_with_args ? addParamToFilteredColumns : addParamsOnRemoveHandler }
                    type = { add_params_with_args ? 'display_settings' : undefined }
                />
            }
            {
                formula &&
                <FormulaModal
                    title="Фильтр"
                    isOpen={formula}
                    onRequestClose={() => handleModal('formula', false)}
                    onApplyClick={ applyFormula }
                    value = { manual_query[caller] }
                />
            }
            {
                are_you_sure &&
                <AreYouSureModal
                    title={ args_provided && args.title || 'title' }
                    isOpen={are_you_sure}
                    onRequestClose={() => handleModal('are_you_sure', false)}
                    onApplyClick={ args_provided ? () => findCallback('are_you_sure', args.action)(args) : () => {} }
                />
            }
            </Suspense>
        </>
    )
}

export default connect((state: RootState) => ({
    modals: state.modals,
    filter_params: state.filter.filterParams,
    selected_filter_params: state.filter.selectedFilterParams,
    quotes: state.quotes,
    active_page_id: state.quotesPage.activePage?.id,
    manual_query: state.filter.manual_query,
    file_query: state.filter.file_query,
    filtered_columns: state.quotes.filtered_columns,
    logic: state.filter.logic
}), {
    showModal,
    selectFilterParam,
    removeFilterParam,
    updateAreaPickedTickers,
    renameTab,
    getTabs,
    filterSection,
    addFilterQuery,
    resetFilterQueries,
    setFilteredColumns,
    selectFilterColumn,
    sendFilteredColumns,
    setUploadedFile,
    setSelectedTickers,
    setFilterParamsForWorkspace
})(ModalHandler);
